<form class="u-bt u-bt--grey u-pt30 " [formGroup]="controlForm">
  <div class="row">
    <div class="col-md-12">
      <h2 class="txt txt--section">
        {{formNumber}}. Detalle de la infracción
      </h2>
      <h3 class="txt txt--paragraph u-mb30">
        Ingresa la información sobre la infracción
      </h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Día de la infracción
        </label>
        <app-calendar [controlForm]="controlFormDay"></app-calendar>
        <app-error-message [text]="dayError"></app-error-message>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form  u-mb50">
        <label for="" class="label">
          Hora de la infracción
        </label>
        <input type="time" placeholder="HH:MM AM" formControlName="hour">
      </div>
    </div>
    <div class="col-md-4">
      <div class="form u-mb50">
        <app-person-finder [controlForm]="controlFormPersonResponsibleId" title="¿Quién es el gerente del infractor?"
          placeHolder="Buscar por nombre, rut* o email" hintText="*El rut debe ser sin puntos y con guión"
          [optional]="true"
          [includeMyself]="true"
        >
        </app-person-finder>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <label for="" class="label">
          Severidad de infracción
        </label>
        <div class="form__radio" *ngFor="let severityType of severityTypes.value">
          <input type="radio" [value]="severityType.id" [id]="'severityType-'+severityType.id"
            formControlName="severityTypeId">
          <label [for]="'severityType-'+severityType.id">
            <div class="fakebox"></div>
            {{severityType.name}}
          </label>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <app-select
        title="Tipo de infracción"
        [controlForm]="controlFormInfrigmentTypeId"
        placeholder="Ingresar"
        [options]="infrigmentTypes.value"
        [biggerOptionSpace]="true"
        [biggerOptionWidth]="true"
        ></app-select>
      </div>
    </div>
    <div class="col-md-4">
      <app-text-area title="Observación de la infracción" placeholder="Puedes ingresar un comentario" [maxlength]="300"
        [controlForm]="controlFormObservation">
      </app-text-area>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form  u-mb50">
        <label for="" class="label">
          ¿Quién reporta la infracción?
        </label>
        <div class="form__radio" *ngFor="let reporterType of reporterTypes.value">
          <input type="radio" [value]="reporterType.id" [id]="'reporterType-'+reporterType.id"
            formControlName="reporterTypeId">
          <label [for]="'reporterType-'+reporterType.id">
            <div class="fakebox"></div>
            {{reporterType.name}}
          </label>
        </div>
        <app-person-finder
          [ngClass]="shouldShowReporterPersonForm ? '' : 'global-unmount'"
          placeHolder="Buscar por nombre, rut* o email"
          [controlForm]="controlFormReporterPersonId"
          [includeMyself]="true"
        ></app-person-finder>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form u-mb50">
        <label for="" class="label">
          Respaldo de infracción (opcional)
        </label>
        <ng-container *ngFor="let evidenceTypeControl of controlFormEvidenceTypes.controls; let i = index">
          <div class="form__check">
            <input type="checkbox" [value]="evidenceTypes[i].id" [id]="'evidenceType-'+evidenceTypes[i].id"
              [formControl]="controlFormEvidenceTypesControl(i)">
            <label [for]="'evidenceType-'+evidenceTypes[i].id">
              <div class="fakebox fakebox--grey"></div>
              {{evidenceTypes[i].name}}
            </label>
          </div>
        </ng-container>
      </div>
    </div>
    <div [ngClass]="shouldShowWitnesForm ? '' : 'global-unmount'" class="col-md-4 active " id="infringement-detail"
      formArrayName="witnesses">
      <div class="form u-mb20">
        <app-person-finder [controlForm]="controlWitnesses.controls[0]" title="Buscar testigo(s) en el sistema"
        [includeMyself]="true"
          placeHolder="Buscar por nombre, rut* o email"
          >

        </app-person-finder>
      </div>
      <div class="form">
        <div class="txt txt--small u-mb5">
          (opcional)
        </div>
        <ng-container *ngFor="let control of controlWitnesses.controls | slice:1;">
          <app-person-finder
          [optional]="true"
           [controlForm]="control"
           [includeMyself]="true"
           >
          </app-person-finder>
        </ng-container>
        <h6 class="form__info">
          *El rut debe ser sin puntos y con guión
        </h6>
      </div>
    </div>
  </div>
</form>
